export const mockTableData = [
    {
        id: "1",
        name: "Soglie 1",
        type: "Cumulativa",
        typeService: "Voce",
        periodicity: "Giornaliero",
        statusText: "Attiva con errori",
        statusColor: "ORANGE",
        tooltipContent: "Contenuto della descrizione comando",
        date: "2022-01-20",
        telephoneNumber: "3956834567"
    },
    {
        id: "2",
        name: "Soglie 2",
        type: "Massiva",
        typeService: "SMS",
        periodicity: "Mensile",
        statusText: "Attiva",
        statusColor: "GREEN",
        tooltipContent: null,
        date: "2022-01-20",
        telephoneNumber: "3956834567"
    },
    {
        id: "3",
        name: "Soglie 3",
        type: "Cumulativa",
        typeService: "Voce",
        periodicity: "Mensile",
        statusText: "Attiva",
        statusColor: "GREEN",
        tooltipContent: null,
        date: "2022-01-20",
        telephoneNumber: "3956834567"
    },
    {
        id: "4",
        name: "Soglie 4",
        type: "Cumulativa",
        typeService: "Voce",
        periodicity: "Giornaliero",
        statusText: "In creazione",
        statusColor: "GRAY",
        tooltipContent: "Contenuto della descrizione comando",
        date: "2022-01-19",
        telephoneNumber: "3956834567"
    },
    {
        id: "5",
        name: "Soglie 5",
        type: "Cumulativa",
        typeService: "SMS",
        periodicity: "Giornaliero",
        statusText: "Attiva con errori",
        statusColor: "ORANGE",
        tooltipContent: "Contenuto della descrizione comando",
        date: "2022-01-18",
        telephoneNumber: "3956834567"
    },
    {
        id: "6",
        name: "Soglie 6",
        type: "Cumulativa",
        typeService: "Voce",
        periodicity: "Giornaliero",
        statusText: "Attiva",
        statusColor: "GREEN",
        tooltipContent: null,
        date: "2022-01-13",
        telephoneNumber: "3956834567"
    }
]

export const createNewSogliaInitialState = {
    associateSims: [],
    loading: false
}

export const createNewRegolaMenuItemsInitialState = {
    loading: false,
    tipoRegola: [],
    oggettoMisurare: [],
    servizio: [],
    direttrice: [],
    periodo: []
}

export const initialThresholdDetails = {
    id: "",
    name: "",
    description: "",
    status: "",
    rules: [],
    elencoSimAssociate: "",
    soglieImpostate: [
        {
            id: "",
            gbValue: "",
            tipologia: "",
            options: [],
            sequence: 0
        }
    ],
    suspended: false,
    loading: false
}

export const modifySimsInitialState = {
    data: [],
    loading: false,
    collaborators: [],
    collaboratorsLoading: false
}

